import page from 'page'

import appStarterPg from '../../config/app-starter-pg.js'
import { contentElementId } from '../../config/config.js'
import { browserAppEntity } from '../../helpers/app-data-loaders/app-entity.js'
import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'

import { showPageCheckVsXero } from './check-vs-xero/index.js'

export function appEntityRoutes (baseRoute) {
  /**
   * Jun 13th, 2025
   */
  page(`${baseRoute}/:accountingOrganisationId/check-vs-xero`, async function (context) {
    const { accountingOrganisationId } = context.params

    await appStarterPg({
      accountingOrganisationId,
      includeTrackings: true
    })

    showPageCheckVsXero({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppEntity,
      accountingOrganisationId
    })
  })
}
